import { PreviewAttachmentController } from './preview-attachment.controller'

const component = {
  templateUrl: '/workflow/components/preview-attachment/preview-attachment.html?$$REVISION$$',
  bindings: {
    art: '=',
    attachment: '<',
    show: '=',
    mActions: '<',
    bCantDownload: '=',
    slider: '<',
    assetToken: '<',
    customize: '<'
  },
  controllerAs: '$ctrl',
  controller: PreviewAttachmentController
}

export const previewAttachment = component
